import styled from "styled-components";
import { Text } from "src/components";

export const SubText = styled(Text)`
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: ${ p => p.weight || 400 };
    text-align: ${p => p.align || "left"};
    color: ${ p => p.color };
    font-size: ${p => p.size || "20px"};
    margin: ${ p => p.margin || 0 };
`;

export const TierCard = styled.div`
    width: 345px;
    height: 90px;
    /* UI Properties */
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px #0000001A;
    border: 1px solid #E0E0E0;
    border-radius: 15px;
    opacity: 1;
    margin-top: 10px
`;


export const TierCardContent = styled.div`
    display: flex;
    align-items: center;       /* vertical center */
    justify-content: space-between; /* push left & right */
    height: 100%;
    padding: 0px 16px;
`;

export const LicenseTextGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const Icon = styled.img`
    width: 20px;
    height: 20px;
`;

export const LicenseTitle = styled.div`
    text-align: left;
    font: normal normal bold 15px/18px Manrope;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
`;

export const LicenseDetails = styled.div`
    text-align: left;
    font: normal normal 500 12px/16px Manrope; /* medium */
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
`;

export const Section = styled.div`
    margin-top: ${p => p.marginTop || "0"};
    width: 70%;
`;

export const SectionHeader = styled.div`
    margin-bottom: 6px;
`;

export const SectionContent = styled.div`
    margin-top: 6px;
`;

export const ActionButtonsWrapper = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
`;

export const CancelButton = styled.button`
    width: 147px;
    height: 39px;
    padding: 10px 18px;
    background: #fff;
    color: #000;
    border: 1px solid #ccc;
    border-radius: 7px;
    cursor: pointer;
    box-shadow: 0px 3px 6px #00000029;

    &:hover {
        background: #f5f5f5;
    }
`;

export const SaveButton = styled.button`
    height: 39px;
    padding: 10px 18px;
    min-width: 160px;
    background: #171A22;
    color: #fff;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    box-shadow: 0px 3px 6px #00000029;

    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

    &:hover {
        background: #0057d6;
    }
`;